export const CircularProgressIcon = () => {
  return (
    <svg
      className="animate-spin-slow text-white"
      width="33"
      height="33"
      viewBox="0 0 33 33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="16.5"
        cy="16.5"
        r="15.5"
        stroke="white"
        strokeOpacity="0.2"
        strokeWidth="2"
      />
      <path d="M1 16C1 7.71573 7.71573 1 16 1" stroke="white" strokeWidth="2" />
    </svg>
  );
};
